import { resolve } from 'node:path';
import { access, readFile } from 'node:fs/promises';
import { constants } from 'node:fs';
import type { ServerWebExchange } from '../../types/web/server';
import { HttpStatus } from '../http/status.ts';
import { mediaType } from './util/matchers.ts';

async function getWelcomePage(staticLocations?: string[]): Promise<string | undefined> {
    if (staticLocations) {
        for (const filePath of staticLocations) {
            const indexHtml = resolve(filePath, 'index.html');
            try {
                await access(indexHtml, constants.R_OK);
                // found readable welcome page
                return indexHtml;
            }
            catch {
                // continue to next candidate
            }
        }
    }
}

export default async function welcomePageFactory(staticLocations?: string[]) {
    const welcomePage = await getWelcomePage(staticLocations);
    const htmlMatcher = mediaType({mediaTypes: ['text/html']});

    return async (exchange: ServerWebExchange, next: () => Promise<void>) => {
        const { request, response } = exchange;
        if (request.method === 'GET' && request.path === '/') {
            response.setStatusCode(HttpStatus.OK);
            if (welcomePage !== undefined && (await htmlMatcher(exchange)).match) {
                response.headers.set('Content-Type', 'text/html; charset=utf-8');
                await response.body(readFile(welcomePage));
            }
            else {
                response.headers.set('Content-Type', 'text/plain; charset=utf-8');
                const buffer = Buffer.from('io.Gateway Server', 'utf-8');
                await response.body(buffer);
            }
        }
        else {
            await next();
        }
    }
}
